const mutations = {
  /**
   * Set the balance property on state
   * with balance parameter.
   *
   * @param state
   * @param balance
   */
  setBalance(state, balance) {
    state.balance = balance;
  },

  /**
   * Set the lastBuy property on state
   * with lastBuy parameter.
   *
   * @param state
   * @param lastBuy
   */
  setLastBuy(state, lastBuy) {
    state.lastBuy = lastBuy;
  },

  setIntent(state, intent) {
    state.intent = intent;
  },

  setPlans(state, plans) {
    state.plans = plans;
  },

  setPlan(state, plan) {
    state.plan = plan;
  },

  setPaymentMethods(state, paymentMethods) {
    state.paymentMethods = paymentMethods;
  },
};

export default mutations;
